<template>
  <button class="copy-button" type="button" @click="copyToClipboard(text)"
          title="Скопировать">
    <svg enable-background="new 0 0 488.3 488.3" version="1.1" viewBox="0 0 488.3 488.3" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m314.25 85.4h-227c-21.3 0-38.6 17.3-38.6 38.6v325.7c0 21.3 17.3 38.6 38.6 38.6h227c21.3 0 38.6-17.3 38.6-38.6v-325.7c-0.1-21.3-17.4-38.6-38.6-38.6zm11.5 364.2c0 6.4-5.2 11.6-11.6 11.6h-227c-6.4 0-11.6-5.2-11.6-11.6v-325.6c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.6z"/><path
        d="m401.05 0h-227c-21.3 0-38.6 17.3-38.6 38.6 0 7.5 6 13.5 13.5 13.5s13.5-6 13.5-13.5c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.7c0 6.4-5.2 11.6-11.6 11.6-7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5c21.3 0 38.6-17.3 38.6-38.6v-325.7c0-21.3-17.3-38.6-38.6-38.6z"/></svg>
  </button>
</template>

<script>
  import copyToClipboard from './../../helpers/copyToClipboard';

  export default {
    props: {
      text: String
    },
    methods: {
      copyToClipboard(str) {
        copyToClipboard(str);
        this.$notify({type: 'success', message: 'Скопировано в буфер обмена'})
      }
    }
  }
</script>

<style lang="scss" scoped>
@import './../../styles/variables.scss';

  .copy-button {
    width: 15px;
    height: 15px;
    background-color: transparent;
    border: none;
    cursor: pointer;

    svg {
      fill: black;

      .dark & {
        fill: $dark-grey;
      }
    }
  }
</style>